module.exports = __webpack_public_path__ + "fcfba77919ebeb47bef74275fdfa47cf.MP3";